<template>
    <article class="user-auth">
        <branding-bar></branding-bar>
        <div class="container-fluid">
            <div class="wrapper">
                <h1>Reset password</h1>
                <vue-form v-if="!formState.$submitted || !errors.$clean" :state="formState" name="forgottenPasswordForm" @submit.prevent="">
                    <p>Enter your email address below to reset your password.</p>
                    <validate class="form-group">
                        <field-messages class="invalid-feedback" name="email" show="$dirty && $invalid">
                            <div slot="required">Email is required</div>
                        </field-messages>
                        <input type="text" id="email" name="email" required class="form-control client-budget" v-model="email">
                        <label for="email">Email*</label>
                    </validate>
                    <section class="form-footer">
                        <button class="btn btn-primary btn-login" @click="forgotPassword" type="submit" :disabled="formState.$invalid">Reset</button>
                        <div class="btn-wrapper">
                            <router-link to="/login">Back to login</router-link>
                        </div>
                    </section>
                </vue-form>
                <div v-else>
                    {{success.message}}
                </div>
            </div>
            <result-message :errors="errors"></result-message>
        </div>
    </article>
</template>

<script>
    import brandingBar from './Header/branding-bar';
    import { mapGetters } from 'vuex';
    import UserServices from '../services/users';

    import ResultMessage from '../helpers/ResultMessage';
    export default {
        components: {
            brandingBar,
            ResultMessage
        },
        data () {
            return {
                formState: {},
                success: {
                    show: false,
                    message: "Success! We have sent password reset instructions to your email."
                },
                errors: {
                    type: Object|Error,
                    $clean: true
                },
                email: '',
            }
        },
        computed: {
            ...mapGetters(['isLoggedIn']),
        },
        methods: {
            forgotPassword() {
                UserServices.forgotPassword(this.email).then(user => {
                    this.errors = {
                        type: Object|Error,
                        $clean: true
                    };
                }).catch((errors) => {
                    this.errors = errors;
                });
            }
        },
    }

</script>
